































import { Component, Vue } from 'vue-property-decorator';
import { Route, RawLocation } from 'vue-router';
import { Form as FormBase, FormData, asFormData } from '@/base';
import { UserJson } from '../json';
import store, { CurrentUserActions } from '../store';

@Component<Account>({
  beforeRouteEnter(to, from, next): void
  {
    next(vm => vm.handleBeforeRouteEnter(to, from, next));
  },
  beforeRouteLeave(to, from, next): void
  {
    this.handleBeforeRouteLeave(to, from, next);
  },
})
export default class Account extends FormBase<FormData<UserJson>>
{
  /**
   * Returns or sets the currently active item.
   */
  public activeItem: FormData<UserJson> | null = null;

  /**
   * Checks if the given item has unsaved changes.
   */
  protected hasUnsavedChanges(item: FormData<UserJson>): boolean
  {
    return item.$isDirty();
  }

  /**
   * Changes the active item.
   */
  protected changeActiveItem(item: FormData<UserJson> | null): void
  {
    const activeItem = this.activeItem;
    this.activeItem = item;

    if (activeItem && (!item || item !== activeItem))
    {
      activeItem.$revoke();
    }
  }

  /**
   * Saves the changes of the given item on the server.
   */
  protected async saveItem(item: FormData<UserJson>): Promise<void>
  {
    const result = await store.currentUser[CurrentUserActions.SAVE](item);
    this.changeActiveItem(asFormData(this.$_.cloneDeep(result), false));
    this.$success(this.$root.$t('form.save.success').toString());
  }

  /**
   * Resets the given item.
   */
  protected resetItem(item: FormData<UserJson>): void
  {
    item.$reset();
  }

  /**
   * Handler for the beforeRouteEnter navigation guard.
   */
  private handleBeforeRouteEnter(to: Route, from: Route, next: (to?: RawLocation | false) => void)
  {
    store.currentUser[CurrentUserActions.GET](true)
      .then(user => this.open(() => asFormData(this.$_.cloneDeep(user))))
      .then(
        handled => next(handled ? undefined : { path: from.fullPath, replace: true }),
        () => next(from.fullPath === '/' && !from.name ? { path: '/', replace: true } : { path: from.fullPath, replace: true }));
  }
}
